import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  '@media (max-width: 1250px)': {
    '@global': {
      '*::-webkit-scrollbar': {
        width: '0.4em'
      },
      '*::-webkit-scrollbar-track': {
        '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
      },
      '*::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,.1)',
        outline: '1px solid slategrey'
      }
    }
  },
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1)
    }
  },
  paper: {
    padding: theme.spacing(2),
    boxShadow: 'none!important',
    border: '1px solid #ddd',
    maxWidth: '500px',
    margin: '0 auto'
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center'
  },
  fileInput: {
    width: '97%',
    margin: '10px 0',
    display: 'flex'
  },
  formControlFile: { width: '85%' },
  CircularProgressbar: { width: '15%' },
  buttonSubmit: {
    marginBottom: 10
  },
  buttonSearch: {
    top: '11px',
    position: 'absolute',
    width: '70px',
    right: '2px',
    height: '50px',
    padding: '0 10px'
  },
  hiddenInput: {
    display: 'none'
  },
  fileInput: {
    width: '100%',
    margin: '10px 0',
    display: 'flex',
    marginLeft: '0px!important',
    backgroundColor: '#fff'
  },
  datePicker: { marginLeft: '0px!important' },
  buttonSubmit: {
    marginBottom: 10
  },
  formControl: { marginTop: '10px' },
  wrapSendBox: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    width: '100%'
  },
  phoneNumberGroup: {
    display: 'flex'
  },
  firstDivision: {
    display: 'flex',
    flex: 1
  },
  addBtn: {
    backgroundColor: 'transparent',
    border: '0px',
    color: 'green',
    margin: 0
  },
  removeBtn: {
    backgroundColor: 'transparent',
    border: '0px',
    color: 'red',
    margin: 0
  },
  secondDivision: {
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    display: 'flex'
  },
  buttonLink: {
    backgroundColor: '#b5131b',
    color: '#fff',
    marginTop: '10px',
    boxShadow:
      '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)'
  },
  listColorCode: {
    float: 'right',
    backgroundColor: '#cacdd3',
    color: '#000',
    marginTop: '10px',
    boxShadow:
      '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)'
  },
  selectLocation: {
    marginTop: '10px'
  }
}))
